import * as Backbone from "backbone";
import {BaseCollection} from "./_BaseCollection";

export interface BacnetUnitRecord {
    name: string;
    number: number;
}

var models: BacnetUnitRecord[] = [
    {name: 'm²', number: 0},
    {name: 'ft²', number: 1},
    {name: 'mA', number: 2},
    {name: 'A', number: 3},
    {name: 'Ω', number: 4},
    {name: 'V', number: 5},
    {name: 'kV', number: 6},
    {name: 'MV', number: 6},
    {name: 'VA', number: 8},
    {name: 'kVA', number: 9},
    {name: 'MVA', number: 10},
    {name: 'VAR', number: 11},
    {name: 'kVAR', number: 12},
    {name: 'MVAR', number: 13},
    {name: '°', number: 14},
    {name: null, number: 15},
    {name: 'J', number: 16},
    {name: 'kJ', number: 17},
    {name: 'Wh', number: 18},
    {name: 'kWh', number: 19},
    {name: 'btu', number: 20},
    {name: 'therm', number: 21},
    {name: 'ton h', number: 22},
    {name: 'J/kg (dry air)', number: 23},
    {name: 'btu/lbs (dry air)', number: 24},
    {name: 'cyc/h', number: 25},
    {name: 'cyc/min', number: 26},
    {name: 'hz', number: 27},
    {name: 'g (water)/kg (dry air)', number: 28},
    {name: '%', number: 29},
    {name: 'mm', number: 30},
    {name: 'm', number: 31},
    {name: 'in', number: 32},
    {name: 'ft', number: 33},
    {name: 'W/ft²', number: 34},
    {name: 'W/m²', number: 35},
    {name: 'lumen', number: 26},
    {name: 'lux', number: 37},
    {name: 'fc', number: 38},
    {name: 'kg', number: 39},
    {name: 'lbm', number: 40},
    {name: 'ton', number: 41},
    {name: 'kg/s', number: 42},
    {name: 'kg/min', number: 43},
    {name: 'kg/h', number: 44},
    {name: 'lbm/min', number: 45},
    {name: 'lbm/h', number: 46},
    {name: 'W', number: 47},
    {name: 'kW', number: 48},
    {name: 'MW', number: 49},
    {name: 'btu/h', number: 50},
    {name: 'hp', number: 51},
    {name: 'TR', number: 52},
    {name: 'Pa', number: 53},
    {name: 'kPa', number: 54},
    {name: 'bar', number: 55},
    {name: 'lbf/in²', number: 56},
    {name: 'cm (water)', number: 57},
    {name: 'in (water)', number: 58},
    {name: 'mmHg', number: 59},
    {name: 'cmHg', number: 60},
    {name: 'inHg', number: 61},
    {name: '°C', number: 62},
    {name: 'K', number: 63},
    {name: '°F', number: 64},
    {name: '°C HDD', number: 65},
    {name: '°F HDD', number: 66},
    {name: 'ys', number: 67},
    {name: 'mo', number: 68},
    {name: 'wk', number: 69},
    {name: 'day', number: 70},
    {name: 'h', number: 71},
    {name: 'min', number: 72},
    {name: 's', number: 73},
    {name: 'm/s', number: 74},
    {name: 'km/h', number: 75},
    {name: 'ft/s', number: 76},
    {name: 'ft/min', number: 77},
    {name: 'mph', number: 78},
    {name: 'ft³', number: 79},
    {name: 'm³', number: 80},
    {name: 'gal', number: 81},
    {name: 'l', number: 82},
    {name: 'gal', number: 83},
    {name: 'ft³/min', number: 84},
    {name: 'm³', number: 85},
    {name: 'gal/min', number: 86},
    {name: 'l/s', number: 87},
    {name: 'l/min', number: 88},
    {name: 'gal/min', number: 89},
    {name: '°', number: 90},
    {name: '°C/h', number: 91},
    {name: '°C/min', number: 92},
    {name: '°F/h', number: 93},
    {name: '°F/min', number: 94},
    {name: null, number: 95},
    {name: 'ppm', number: 96},
    {name: 'ppb', number: 97},
    {name: '%', number: 98},
    {name: '%/s', number: 99},
    {name: '/min', number: 100},
    {name: '/s', number: 101},
    {name: 'psi/°F', number: 102},
    {name: 'rad', number: 103},
    {name: 'rev/min', number: 104},
    {name: null, number: 105},
    {name: null, number: 106},
    {name: null, number: 107},
    {name: null, number: 108},
    {name: null, number: 109},
    {name: null, number: 110},
    {name: null, number: 111},
    {name: null, number: 112},
    {name: null, number: 113},
    {name: null, number: 114},
    {name: 'in²', number: 115},
    {name: 'cm²', number: 116},
    {name: 'btu/lb', number: 117},
    {name: 'cm', number: 118},
    {name: 'lbm/s', number: 119},
    {name: 'Δ°F', number: 120},
    {name: 'Δ°K', number: 121},
    {name: 'kΩ', number: 122},
    {name: 'MΩ', number: 123},
    {name: 'mV', number: 124},
    {name: 'kJ/kg', number: 125},
    {name: 'MJ', number: 126},
    {name: 'J/K', number: 127},
    {name: 'J/kg°K', number: 128},
    {name: 'kHz', number: 129},
    {name: 'MHz', number: 130},
    {name: '/h', number: 131},
    {name: 'mW', number: 132},
    {name: 'hPa', number: 133},
    {name: 'mbar', number: 134},
    {name: 'm³/h', number: 135},
    {name: 'L/h', number: 136},
    {name: 'kWh/m²', number: 137},
    {name: 'kWh/ft²', number: 138},
    {name: 'MJ/m²', number: 139},
    {name: 'MJ/ft²', number: 140},
    {name: 'W/m²°K', number: 141},
    {name: 'ft³/s', number: 142},
    {name: '%obs/ft', number: 143},
    {name: '%obs/m', number: 144},
    {name: 'mΩ', number: 145},
    {name: 'MWh', number: 146},
    {name: 'kbtu', number: 147},
    {name: 'Mbtu', number: 148},
    {name: 'kJ/kg(dry-air)', number: 149},
    {name: 'MJ/kg(dry-air)', number: 150},
    {name: 'kJ/K', number: 151},
    {name: 'MJ/K', number: 152},
    {name: 'N', number: 153},
    {name: 'g/s', number: 154},
    {name: 'g/m', number: 155},
    {name: 'ton/h', number: 156},
    {name: 'kbtu/h', number: 157},
    {name: '1/100 s', number: 158},
    {name: 'ms', number: 159},
    {name: 'Nm', number: 160},
    {name: 'mm/s', number: 161},
    {name: 'mm/min', number: 162},
    {name: 'm/min', number: 163},
    {name: 'm/h', number: 164},
    {name: 'm³/min', number: 165},
    {name: 'm/s²', number: 166},
    {name: 'A/m', number: 167},
    {name: 'A/m²', number: 168},
    {name: 'Am²', number: 169},
    {name: 'F', number: 170},
    {name: 'H', number: 171},
    {name: 'Ωm', number: 172},
    {name: 'S', number: 173},
    {name: 'S/m', number: 174},
    {name: 'T', number: 175},
    {name: 'V/K', number: 176},
    {name: 'V/m', number: 177},
    {name: 'Wb', number: 178},
    {name: 'cd', number: 179},
    {name: 'cd/m²', number: 180},
    {name: 'K/h', number: 181},
    {name: 'K/min', number: 182},
    {name: 'Js', number: 183},
    {name: 'rad/s', number: 184},
    {name: 'm²/N', number: 185},
    {name: 'k/m³', number: 186},
    {name: 'Ns', number: 187},
    {name: 'N/m', number: 188},
    {name: 'W/m/K', number: 189},
    {name: 'μS', number: 190},
    {name: 'ft³/h', number: 191},
    {name: 'gal/h', number: 192},
    {name: 'km', number: 193},
    {name: 'μm', number: 194},
    {name: 'g', number: 195},
    {name: 'mg', number: 196},
    {name: 'ml', number: 197},
    {name: 'ml/s', number: 198},
    {name: 'dB', number: 199},
    {name: 'dBmV', number: 200},
    {name: 'dBV', number: 201},
    {name: 'mS', number: 202},
    {name: 'WhR', number: 203},
    {name: 'kWhR', number: 204},
    {name: 'MWhR', number: 205},
    {name: 'ml', number: 206},
    {name: '‰', number: 207},
    {name: 'g/g', number: 208},
    {name: 'kg/kg', number: 209},
    {name: 'g/kg', number: 210},
    {name: 'mg/g', number: 211},
    {name: 'mg/kg', number: 212},
    {name: 'g/ml', number: 213},
    {name: 'g/l', number: 214},
    {name: 'mg/l', number: 215},
    {name: 'μg/l', number: 216},
    {name: 'g/m³', number: 217},
    {name: 'mg/m³', number: 218},
    {name: 'μg/m³', number: 219},
    {name: 'ng/m³', number: 220},
    {name: 'g/cm³', number: 221},
    {name: 'Bq', number: 222},
    {name: 'kBq', number: 223},
    {name: 'MBq', number: 224},
    {name: 'Gy', number: 225},
    {name: 'mGy', number: 226},
    {name: 'μGy', number: 227},
    {name: 'Sv', number: 228},
    {name: 'mSv', number: 229},
    {name: 'μSv', number: 230},
    {name: 'μSv/h', number: 231},
    {name: 'dB(A)', number: 232},
    {name: 'NTU', number: 233},
    {name: 'pH', number: 234},
    {name: 'g/m²', number: 235},
    {name: 'min/K', number: 236}
];


export class BacnetUnitCollection extends BaseCollection<Backbone.Model> {
    url = null;

    initialize() {
        this.add(models);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/BacnetUnits.ts